import BaseView from './BaseView';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

let view = null;

class Subrosa extends BaseView {
	constructor(container) {
		super(container);

		this.main = this.container.querySelector('[data-subrosa-main]');

		this.dot1 = this.container.querySelector('[data-subrosa-dot-1]');
		this.dot2 = this.container.querySelector('[data-subrosa-dot-2]');

		this.illustration = this.container.querySelector('[data-subrosa-illustration]');
		gsap.set(this.illustration, {
			yPercent: -120,
		});

		this.revealRose();
	}

	init() {
		gsap.to(this.dot1, {
			scrollTrigger: {
				trigger: this.main,
				start: 'top ' + this.main.getBoundingClientRect().top,
				end: 'bottom top',
				scrub: true,
			},
			ease: 'none',
			y: () => {
				return this.main.getBoundingClientRect().height;
			},
			yPercent: -100,
		});
		gsap.fromTo(
			this.dot2,
			{
				yPercent: 95,
			},
			{
				yPercent: -5,
				scrollTrigger: {
					trigger: this.main,
					start: 'top ' + this.main.getBoundingClientRect().top,
					end: 'bottom top',
					scrub: true,
				},
			}
		);


	}

	revealRose() {
		gsap.to(this.illustration, {
			yPercent: 0,
			duration: 3.2,
			delay: 0,
			ease: 'expo.out',
		});
	}
}

export default {
	namespace: 'template-subrosa',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Subrosa(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
